<pgh-modal-window>
  <div modal-close>
    <button mat-icon-button class="close-button mat-icon-button" (click)="onCancelClicked()" sf-aria-label="Global_Close_Window" matDialogClose>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <h4 modal-title><adp-label labelKey="DeviceContentRequest_Modal_Title"></adp-label></h4>
  <div modal-body class="mt-25 mb-25">
    <div class="form-subtitle">
      <adp-label labelKey="DeviceContentRequest_Modal_SubTitle" [context]="subTitle"></adp-label>
    </div>
    <form [formGroup]="requestDeviceContentForm" name="RequestDeviceContentFormGroup" class="device-request-form">

      <div class="row">
        <mat-checkbox matInput formControlName="manuals" class="checkbox-field" (change)="onCheckboxChanged($event)" value="MANUALS"><adp-label labelKey="DeviceContentRequest_Modal_UserManual_Label"></adp-label></mat-checkbox>
      </div>
      <div class="row">
        <mat-checkbox matInput formControlName="videos" class="checkbox-field" (change)="onCheckboxChanged($event)" value="VIDEOS"><adp-label labelKey="DeviceContentRequest_Modal_Videos_Label"></adp-label></mat-checkbox>
      </div>
      <div class="row">
        <mat-checkbox matInput formControlName="lifestyle" class="checkbox-field" (change)="onCheckboxChanged($event)" value="LIFESTYLE"><adp-label labelKey="DeviceContentRequest_Modal_TipsTricks_Label"></adp-label></mat-checkbox>
      </div>
      <div class="row">
        <mat-form-field class="textarea-field">
          <mat-label> <adp-label labelKey="DeviceContentRequest_Modal_UserComments_Label"></adp-label></mat-label>
          <textarea matInput #input formControlName="user_comments" maxlength="180" placeholder="Start typing"></textarea>
          <mat-hint align="end"><adp-label labelKey="DeviceContentRequest_Modal_Minimum10Characters"></adp-label> {{input.value?.length || 0}}/180</mat-hint>
        </mat-form-field>
      </div>
    </form>
  </div>
  <div modal-footer class="row reverse-wrap">
    <div class="col-12 col-sm-6 mb-10">
      <button mat-stroked-button color="primary" class="border-0" (click)="onCancelClicked()"><adp-label labelKey="Global_Button_Cancel"></adp-label></button>
    </div>
    <div class="col-12 col-sm-6">
      <button mat-flat-button color="accent" [disabled]="contentCategoriesSelected.length == 0 || input.value?.length < 10" (click)="onSubmitClicked()"><adp-label labelKey="DeviceContentRequest_Modal_Button_Submit"></adp-label></button>
    </div>
  </div>
</pgh-modal-window>
